import { useCallback } from 'react'
import { useLocale } from '../utils/locale'
import { staticDictionary } from './dictionary'
export const useStaticTranslate = () => {
  const locale = useLocale()
  const getTranslation = useCallback(
    (key: keyof typeof staticDictionary) => {
      return staticDictionary[key]?.[locale as 'ru' | 'en'] ?? key
    },
    [locale]
  )
  return getTranslation
}
